// @ts-nocheck
import {Provider} from '@angular/core';
import {NG_DOC_CONTEXT} from '@ng-doc/app/tokens';

export function provideNgDocContext(): Provider {
    return {
        provide: NG_DOC_CONTEXT,
        useValue: {
            navigation: [
                
                {
                    title: `Secure Class Unified Browser Security`,
                    route: '/acium-docs-overview',
                    order: 1,
                    hidden: false,
                },
                
                {
                    title: `Get started`,
                    route: '/get-started',
                    expandable: true,
                    expanded: false,
                    order: 2,
                    hidden: false,
                    children: [
                        
                {
                    title: `Sign up for a free trial`,
                    route: '/get-started/sign-up',
                },
                        
                {
                    title: `Plan your deployment`,
                    route: '/get-started/plan',
                    order: 1,
                    hidden: false,
                },
                        
                {
                    title: `Secure Class UBS basics`,
                    route: '/get-started/filtering-basics',
                },
                        
                {
                    title: `Set up your organization`,
                    route: '/get-started/set-up-your-organization',
                },
                    ]
                },
                
                {
                    title: `Integrations`,
                    route: '/directory-integration',
                    order: 3,
                    hidden: false,
                },
                
                {
                    title: `Browser settings`,
                    route: '/browser-settings',
                    order: 4,
                    hidden: false,
                },
                
                {
                    title: `Extension management`,
                    route: '/browser-extensions',
                    order: 5,
                    hidden: false,
                },
                
                {
                    title: `Web filtering`,
                    route: '/web-filtering',
                    expandable: true,
                    expanded: false,
                    order: 7,
                    hidden: false,
                    children: [
                        
                {
                    title: `URL filtering`,
                    route: '/web-filtering/url-filtering',
                    order: 2,
                    hidden: false,
                },
                        
                {
                    title: `Site category filtering`,
                    route: '/web-filtering/site-category-filtering',
                    order: 3,
                    hidden: false,
                },
                        
                {
                    title: `YouTube filtering`,
                    route: '/web-filtering/youtube-filtering',
                    order: 4,
                    hidden: false,
                },
                    ]
                },
                
                {
                    title: `Policy assignment`,
                    route: '/policy-assignment',
                    order: 8,
                    hidden: false,
                },
                
                {
                    title: `Install`,
                    route: '/install',
                    expandable: true,
                    expanded: false,
                    order: 9,
                    hidden: false,
                    children: [
                        
                {
                    title: `Install the extension for Google Chrome`,
                    route: '/install/install-chrome-extension',
                    order: 1,
                    hidden: false,
                },
                        
                {
                    title: `Install the extension on managed Chrome browsers`,
                    route: '/install/install-gsuite-extension',
                    order: 2,
                    hidden: false,
                },
                        
                {
                    title: `Install the extension for Mozilla Firefox`,
                    route: '/install/install-firefox-extension',
                    order: 3,
                    hidden: false,
                },
                        
                {
                    title: `Install the extension for Microsoft Edge`,
                    route: '/install/install-edge-extension',
                    order: 4,
                    hidden: false,
                },
                        
                {
                    title: `Install the sensor`,
                    route: '/install/install-sensor',
                    order: 5,
                    hidden: false,
                },
                        
                {
                    title: `No-Touch Login via Sensor`,
                    route: '/install/no-touch-login-sensor',
                    order: 6,
                    hidden: false,
                },
                    ]
                },
                
                {
                    title: `Browser activity`,
                    route: '/browser-activity',
                    order: 10,
                    hidden: false,
                },
                
                {
                    title: `Threat protection`,
                    route: '/threat-protection',
                    order: 11,
                    hidden: false,
                },
                
                {
                    title: `Site Exceptions`,
                    route: '/site-exceptions',
                    expandable: true,
                    expanded: false,
                    order: 11,
                    hidden: true,
                    children: [
                        
                {
                    title: `Review Requests`,
                    route: '/site-exceptions/review-requests',
                    order: 1,
                    hidden: false,
                },
                        
                {
                    title: `Category Overrides`,
                    route: '/site-exceptions/category-overrides',
                    order: 2,
                    hidden: false,
                },
                    ]
                },
                
                {
                    title: `Manage`,
                    route: '/manage',
                    expandable: true,
                    expanded: false,
                    order: 12,
                    hidden: false,
                    children: [
                        
                {
                    title: `Administrators`,
                    route: '/manage/administrators',
                    order: 1,
                    hidden: false,
                },
                        
                {
                    title: `Configuration profiles`,
                    route: '/manage/configuration-profiles',
                    order: 2,
                    hidden: false,
                },
                        
                {
                    title: `Users`,
                    route: '/manage/users',
                },
                    ]
                },
                
                {
                    title: `Events`,
                    route: '/events',
                    order: 13,
                    hidden: false,
                },
                
                {
                    title: `Health Check`,
                    route: '/health-check',
                    order: 14,
                    hidden: false,
                },
                
                {
                    title: `Reference`,
                    route: '/reference',
                    expandable: true,
                    expanded: false,
                    order: 20,
                    hidden: false,
                    children: [
                        
                {
                    title: `Site Categories Reference`,
                    route: '/reference/site-categories',
                },
                        
                {
                    title: `Youtube categories`,
                    route: '/reference/youtube-categories',
                },
                    ]
                },
            ],
        }
    };
}
